import React from "react";
import { Box, Text } from "grommet";
import { LinkPrevious } from "grommet-icons";
import { useNavigate } from "react-router-dom";

const BreadcrumbNavigation = ({ breadcrumbs = [] }) => {
  const navigate = useNavigate();

  return (
    <Box
      direction="row"
      align="center"
      gap="small"
      margin={{ top: "medium", horizontal: "medium" }}
    >
      <LinkPrevious
        color="brand"
        size="medium"
        onClick={() => navigate(-1)}
        cursor="pointer"
      />
      {breadcrumbs.map((crumb, index) => (
        <Box key={index} direction="row" align="center" gap="small">
          {index > 0 && (
            <Text size="large" weight="bold">
              /
            </Text>
          )}
          <Text
            size="large"
            onClick={() => navigate(crumb.link)}
            style={{ cursor: "pointer" }}
            weight="bold"
          >
            {crumb.label}
          </Text>
        </Box>
      ))}
    </Box>
  );
};

export default BreadcrumbNavigation;
